import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { injectIntl } from "react-intl";

let collator;
if (typeof Intl === "object") {
  collator = new Intl.Collator("pl", { sensitivity: "base" });
}

const sortTable = (a, b) => {
  if (collator !== null && typeof a === "string" && typeof b === "string") {
    return collator.compare(a, b);
  } else {
    return a > b ? 1 : -1;
  }
};

/**
 * Komponent tabeli
 */
class FlowTable extends React.Component {

  /**
   * Akcja kliknięcia na wiersz tabelki
   */
  onRowClick = data => {
    this.props.onRowClick(data.original);
  };

  /**
   * Zwraca style dla elementu tabelki tr - wiersz.
   * 
   * Domyślnie jest linia 1.5 i czcionka 15px - tutaj to zmniejszamy
   */
  getTrProps = (state, rowInfo, instance) => {
    return {
      style: {
        lineHeight: 1.4,
        fontSize: '13px'
      }
    }

  }

  render() {
    let { data, columns, loading, filterable, showPagination, SubComponent, onExpandedChange, expanded } = this.props;

    //jesli w tabelce nie mamy zadnych wierszy - nie wyswietlamy tabelki
    //if (!data.length) {
    //  return <div>No Data</div>;
    //}

    return (
      <div>
        <ReactTable
          data={data}
          columns={columns}
          defaultPageSize={10}
          minRows={10}
          filterable={filterable}
          defaultSortMethod={(a, b) => {
            a = a === null || a === undefined ? "" : a;
            b = b === null || b === undefined ? "" : b;

            a = typeof a === "string" ? a.toLowerCase() : a;
            b = typeof b === "string" ? b.toLowerCase() : b;

            return sortTable(a, b);
          }}
          defaultFilterMethod={(filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== undefined) {
              return (

                //String(row[id])
                //  .toLowerCase()
                //  .search(filter.value.toLowerCase()) !== -1

                //zmieniam na includes poniewaz search przyjmuje regex, i wywala sie przy niedozwolonych znakach np \
                String(row[id])
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())

              );
            } else {
              return true;
            }
          }}
          className="-striped -highlight"
          showPagination={showPagination}
          previousText={this.props.intl.formatMessage({ id: "app.flowTable.previous" })}
          nextText={this.props.intl.formatMessage({ id: "app.flowTable.next" })}
          pageText={this.props.intl.formatMessage({ id: "app.flowTable.page" })}
          ofText={this.props.intl.formatMessage({ id: "app.flowTable.of" })}
          rowsText={this.props.intl.formatMessage({ id: "app.flowTable.rows" })}
          noDataText={this.props.intl.formatMessage({ id: "app.flowTable.noData" })}
          loading={loading}
          getTrProps={this.getTrProps}
          SubComponent={SubComponent}
          onExpandedChange={onExpandedChange}
          expanded={expanded}
        />
      </div>
    );
  }
}

FlowTable.defaultProps = {
  /**
   * Określa czy tabelka jest filtrowalna, domyślnie TAK
   */
  filterable: true,
  /**
   * Określa czy pokazujemy panel ze stronicowaniem, domyślnie TAK
   */
  showPagination: true
}

FlowTable.propTypes = {
  /**
   * Dane wyświetlane w tabelce
   */
  data: PropTypes.array.isRequired,
  /**
   * Model kolumn
   */
  columns: PropTypes.array.isRequired,
  /**
   * Ładowanie tabelki
   */
  loading: PropTypes.bool.isRequired,
  /**
   * Określa czy tabelka jest filtrowalna, domyślnie TAK
   */
  filterable: PropTypes.bool,
  /**
   * Określa czy pokazujemy panel ze stronicowaniem, domyślnie TAK
   */
  showPagination: PropTypes.bool,
  /**
   * Określa komponent, który ukazuje się w rozszerzonym wierszu
   */
  SubComponent: PropTypes.func,
  /**
   * Określa funkcję na zmianę rozszerzenia wiersza w tabelce
   */
  onExpandedChange: PropTypes.func,
  /**
   * Określa model domyślnie rozszerzonych wierszy 
   * np. {0:true, 1:false, 2:true] oznacza że wiersze o indexie 0 i 2 są rozwinięte
   */
  expanded: PropTypes.object
};

export default injectIntl(FlowTable);
